var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            "show-loading": _vm.loading,
            "action-collapse": "",
            title: _vm.$t("Configuração do Contrato de Comodato"),
          },
        },
        [
          _c(
            "FormulateForm",
            {
              ref: "lendingContractForm",
              attrs: { name: "lendingContractForm" },
              on: { submit: _vm.saveConfiguration },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "lending_contract-version",
                          type: "text",
                          label: _vm.$t("Versão do Contrato"),
                          placeholder: _vm.$t("Ex: 1.0, 2.1, etc."),
                          maxlength: "10",
                          validation: "required|max:10",
                          "validation-behavior": "live",
                          help: _vm.$t("Máximo 10 caracteres"),
                        },
                        model: {
                          value: _vm.configuration.version,
                          callback: function ($$v) {
                            _vm.$set(_vm.configuration, "version", $$v)
                          },
                          expression: "configuration.version",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "lending_contract-content",
                          type: "textarea",
                          rows: "50",
                          label: _vm.$t("Conteúdo do Contrato"),
                          placeholder: _vm.$t(
                            "Digite aqui o conteúdo completo do contrato de comodato..."
                          ),
                          validation: "required",
                          "validation-behavior": "live",
                          help: _vm.$t(
                            "Este texto será exibido como referência para o contrato de comodato"
                          ),
                        },
                        model: {
                          value: _vm.configuration.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.configuration, "content", $$v)
                          },
                          expression: "configuration.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12", align: "right" } },
                    [
                      _c("e-button", {
                        staticClass: "mr-2",
                        attrs: {
                          id: "cancel_lending_contract",
                          type: "button",
                          variant: "outline-secondary",
                          icon: "x",
                          text: _vm.$t("Cancelar"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$router.go(-1)
                          },
                        },
                      }),
                      _c("e-button", {
                        attrs: {
                          id: "save_lending_contract",
                          type: "submit",
                          variant: "primary",
                          icon: "save",
                          text: _vm.$t("Salvar"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }